import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    CalibrationId,
    CalibrationRowSpacingMin
} from 'services/equipmentSets/types';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex } from 'services/worksheet/types';
import Bold from 'components/Bold';
import { makeSelectMaxRowWidth } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    calibrationId: CalibrationId;
}

interface ConnectedProps {
    maxRowWidth: CalibrationRowSpacingMin;
}

type Props = OwnProps & ConnectedProps;

export class MaxRowWidthTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { maxRowWidth } = this.props;

        return (
            <TableCell>
                <Bold>{maxRowWidth}m</Bold>
            </TableCell>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    maxRowWidth: makeSelectMaxRowWidth()
});

export default connect(mapStateToProps)(MaxRowWidthTableCellComponent);
